import { IssueReportService } from "../resource";

const IssueReportModule = {
    namespaced: true,
    state: {},
    mutations: {},
    actions: {
        Create({ commit, state }, payload) {
            return IssueReportService.Create(payload);
        },
        List({ commit, state }, params) {
            return IssueReportService.List(params);
        },
        Sync({ commit, state }) {
            return IssueReportService.Sync();
        }
    },
    getters: {}
};

export default IssueReportModule;
